var render = function (_h,_vm) {var _c=_vm._c;return _c('td',_vm._b({class:[
    _vm.data.class,
    _vm.data.staticClass
  ]},'td',_vm.data.attrs,false),[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
  var on = ref.on;
return [_c('span',_vm._g({},on),[_vm._v(" "+_vm._s((_vm.props.value !== null) ? _vm.props.value.toPrecision(3) : '')+" ")])]}}])},[_c('span',[_vm._v(" "+_vm._s((_vm.props.value !== null) ? _vm.props.value : '')+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }